export default "__VITE_ASSET__BeQhgfNC__"